import { EvaluatorFeedbackSchema } from '@/components/EvaluatorCrudPane/EvaluatorFeedbackSchema';

export const EvaluatorPlaygroundFeedbackSchemaPanel = () => {
  return (
    <div className="flex h-full flex-col gap-4 px-2 pt-4">
      <div className="text-sm font-semibold">Feedback config</div>
      <div className="overflow-y-auto">
        <EvaluatorFeedbackSchema
          evaluatedEntityType="dataset-eval"
          readOnly={true}
          isAlignEvaluator={true}
          hideDescriptionAndControls={true}
          isEvaluatorPlayground={true}
        />
      </div>
    </div>
  );
};
